export const DetachIcon = () => {
	return (
		<svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="40" height="36" rx="8" fill="white" />
			<g clipPath="url(#clip0_13362_101853)">
				<path
					d="M25.6974 18.2077L27.1307 16.7827H27.1141C27.8813 15.9877 28.3016 14.9208 28.2829 13.8162C28.2641 12.7115 27.8078 11.6595 27.0141 10.891C26.2365 10.1412 25.1984 9.72217 24.1182 9.72217C23.038 9.72217 21.9999 10.1412 21.2224 10.891L19.7891 12.316M14.3057 17.791L12.8807 19.216C12.1135 20.011 11.6932 21.0779 11.7119 22.1825C11.7307 23.2872 12.187 24.3392 12.9807 25.1077C13.7583 25.8575 14.7964 26.2765 15.8766 26.2765C16.9568 26.2765 17.9949 25.8575 18.7724 25.1077L20.1974 23.6827M16.6641 9.66602V12.166M11.6641 14.666H14.1641M23.3307 23.8327V26.3327M25.8307 21.3327H28.3307"
					stroke="#ED0100"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_13362_101853">
					<rect width="20" height="20" fill="white" transform="translate(10 8)" />
				</clipPath>
			</defs>
		</svg>
	)
}
